<template >
    <div @click="$emit('click')" style="font-size: 13px;padding-top: 2px">
        <!--  Muted  -->
        <span v-if="muted || volume === 0">
            <font-awesome-icon icon="volume-mute" />
        </span>


        <!-- Low Volume -->
        <span v-else-if="volume < 0.5">
            <font-awesome-icon icon="volume-down" />
        </span>

        <!--  Medium Volume  -->
<!--        <span v-else-if="volume < 0.8">-->
<!--            <font-awesome-icon icon="volume" />-->
<!--        </span>-->


        <!-- Max Volume  -->
        <span v-else>
            <font-awesome-icon icon="volume-up" />
        </span>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'Volume',
        computed:{
            ...mapGetters([
                'muted',
                'volume'
            ])
        }
    }
</script>

<style>
    .st0{fill:#FFFFFF;}

</style>